import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { SimpleDropdownItem } from "@similarweb/ui-components";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const FILTER_WIDTH = "296px";

const { carbon } = colorsPalettes;

export const EllipsisContainer = styled.span`
    display: inline;
    width: ${FILTER_WIDTH};
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`;

export const StyledDropdownItem = styled.span<{ isChild: boolean }>`
    font-weight: ${({ isChild }) => (isChild ? "400" : "500")};
    margin-left: ${({ isChild }) => (isChild ? "28px" : "0px")};
`;

export const StyledIndustriesFilterContainer = styled.div`
    width: 100%;

    & .DropdownButton {
        background: ${carbon[0]};
    }

    .DropdownButton--opened {
        background-color: ${carbon[0]};
        color: ${carbon[200]};
    }
`;

export const StyledDropdownWrapper = styled(SimpleDropdownItem)`
    .icon-checked {
        display: none;
    }
`;

const Container = styled(FlexColumn)`
    gap: 4px;
`;

const Label = styled.label`
    ${setFontVariant("caption", carbon[300])};
`;

export const DropdownAndIconWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    gap: 5px;
`;
